var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EntityList',{attrs:{"config":_vm.config,"columns":_vm.columns,"form-fields":_vm.formFields,"authority":"General_Registration_Period"}})}
var staticRenderFns = []

export { render, staticRenderFns }